import {
  ApplicationDispatch, GET_APPLICATION_REHASH_SUCCESS,
  SET_SERVER_MESSAGE
} from "../store/application/types";
import {fetchData} from "./fetch";
import {IApplicationRehash} from "../Interfaces/Application/IApplicationRehash";
import { AppState } from '../store/rootReducer';

export const getApplicationRehashes = (applicationId: string) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      const url = `api/ApplicationRehash/GetApplicationRehashes/${applicationId}`;
      const result: IApplicationRehash[] | {message: string} = await fetchData(url, dispatch);
      if ((result as {message: string}).message !== undefined) {
      } else {
        if (result !== undefined) {
          dispatch({
            type: GET_APPLICATION_REHASH_SUCCESS,
            payload: {applicationRehashes: result as IApplicationRehash[]}
          });
        }
      }
    } catch (err) {
      window.console.log('unknown error occurred')
      window.console.log('ERROR__', err);
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  }
}

export const acknowledgeApplicationRehash = (applicationRehashId: string, applicationId: string) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      const url = `api/ApplicationRehash/AcknowledgeApplicationRehash/${applicationRehashId}`;
      const result: {isError: boolean, message: string} = await fetchData(url, dispatch);
      if (result.message !== undefined) {
        console.log((result as {message: string}).message);
        dispatch({
          type: SET_SERVER_MESSAGE,
          payload: { isError: result.isError, message: result.message },
        });
      }
    } catch (err) {
      window.console.log('unknown error occurred')
      window.console.log('ERROR__', err);
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  }
}